import { GradeIcon } from '~/@mid_ui/icons/GradeIcon'
import { HeadingThree } from '~/@mid_ui/typography/HeadingThree'
import { Text } from '~/@mid_ui/typography/Text'

export function LoginInfoSection() {
  const benefits = [
    'Pripravili sme si pre Vás novú vylepšenú verziu aplikácie Invest in Slovakia',
    'Máme pre vás ešte zaujímavejšie a výhodnejšie možnosti investícií',
    'Aktualizujte si svoj investorský účet a už dnes začnite zhodnocovať svoje financie',
  ]

  return (
    <div className="flex flex-col justify-center items-start max-w-400 gap-8 px-20">
      <HeadingThree className="text-2xl text-primary-foreground">
        Vitajte späť :)
      </HeadingThree>
      <div className="flex flex-col gap-6">
        {benefits.map((benefitText, index) => (
          <div
            className="flex flex-row items-start text-primary-foreground font-semibold"
            key={index}>
            <GradeIcon className="w-8 mr-2" />
            <Text className="text-primary-foreground">{benefitText}</Text>
          </div>
        ))}
      </div>
    </div>
  )
}
